export default 'https://tme.understood.org/assets/global_outro.en.fa0de782.vtt'